<template>
  <div class="taobao-box">
    <van-nav-bar
      title="苏宁易购商品搜索"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <vueSearch @onSearch="onSearch"></vueSearch>
    <good v-for="(item,index) in goodList"
       :good="item"
      :key="index">
    </good>
    <div v-show="goodList.length === 0">
      <van-empty description="暂无搜索结果" />
    </div>
    <van-button type="default" size="large" v-show="more && goodList.length > 0" @click="loadMore"
      >加载更多</van-button
    >
  </div>
</template>

<script>
import good from "@/components/sunning/good";
export default {
  components: {
    good,
  },
  data() {
    return {
      goodList: [], // 搜索结果
      page: 1,
      more: true,
      keyword: "",
    };
  },
  methods: {
    onSearch(keyword) {
      this.page = 1;
      this.keyword = keyword;
      this.Post(
        {
          keyword,
          page: this.page,
        },
        "/sunning/searchcommodity",
        (res) => {
          if (res.states == 1) {
               let good = res.data.sn_responseContent.sn_body.querySearchcommodity || [];
          if(good.length === 0){
            this.more = false
          }
          this.goodList = good;
          }
        }
      );
    },
    // 加载更多
    loadMore() {
      if (this.more) {
        this.page++;
        this.Post(
          {
            keyword:this.keyword,
            page: this.page,
          },
          "/sunning/searchcommodity",
          (res) => {
            if (res.states == 1) {
                 let good = res.data.sn_responseContent.sn_body.querySearchcommodity || [];
          if(good.length === 0){
            this.more = false
          }
          this.goodList = this.goodList.concat(good);
            }
          }
        );
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/sunning/search.vue